import BgImageToggler from './BgImageTogglerContainer';
export default BgImageToggler;